// This file is auto-generated by the "tsproxygen.exe" tool. Manual modification is not recommended.
import type RestrictionType from "../contract/RestrictionType";

export default function restrictionType(data: RestrictionType): RestrictionType {
    const result: RestrictionType = {
        __type: "RestrictionType:#Exchange",
        ...data,
    };
    
    return result;
}
